import { render, staticRenderFns } from "./VEmployerEmployeesTemplateDocuments.vue?vue&type=template&id=f607a1cc&lang=pug"
import script from "./VEmployerEmployeesTemplateDocuments.vue?vue&type=script&lang=ts"
export * from "./VEmployerEmployeesTemplateDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports